"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserEngageCard = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _LinkWrapper = _interopRequireDefault(require("./LinkWrapper"));
var _isomorphicDompurify = _interopRequireDefault(require("isomorphic-dompurify"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    imageHeight: (0, _defineProperty2.default)({
      position: 'relative',
      background: 'transparent',
      width: '35px',
      height: '35px',
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'end'
    }, theme.breakpoints.down('xs'), {
      width: '32px',
      height: '32px',
      marginBottom: theme.spacing(4)
    }),
    imgResponsive: {
      width: '100%',
      objectFit: 'cover'
    }
  };
});
var UserEngageCard = function UserEngageCard(_ref) {
  var cardImageAltTxt = _ref.cardImageAltTxt,
    cardImageReference = _ref.cardImageReference,
    cardImageTitle = _ref.cardImageTitle,
    externalLink = _ref.externalLink,
    untransformedUrl = _ref.untransformedUrl,
    url = _ref.url,
    title = _ref.title;
  var _url = url !== null && url !== void 0 ? url : '';
  var classes = useStyles();
  var getLabel = function getLabel(label) {
    var sanitizedContent = _isomorphicDompurify.default.sanitize(label);
    var parsedContent = (0, _htmlReactParser.default)(sanitizedContent);
    return parsedContent;
  };
  return __jsx(_react.default.Fragment, null, _url ? __jsx(_LinkWrapper.default, {
    thumbnail: cardImageReference,
    externalUrl: externalLink,
    url: _url
  }, __jsx("div", {
    className: classes.imageHeight
  }, __jsx("img", {
    src: cardImageReference,
    className: classes.imgResponsive,
    alt: cardImageAltTxt,
    title: cardImageTitle
  })), __jsx("span", null, getLabel(title))) : __jsx(_react.default.Fragment, null, __jsx("div", {
    className: classes.imageHeight
  }, __jsx("img", {
    src: cardImageReference,
    className: classes.imgResponsive,
    alt: cardImageAltTxt,
    title: cardImageTitle
  })), __jsx("span", null, title)));
};
exports.UserEngageCard = UserEngageCard;